import { log } from '../../engine/log-sidecar'
import { settings } from '../../engine/settings-sidecar'
import { soundsGeneric } from '../../engine/soundsGeneric-sidecar'
import { _audioSprite2 } from '../goat/sound/_audioSprite2-sidecar'

let doPlayLoaded = false
let soundTest = false

let _musicPath = ''

export function getMusicPath() {
  return _musicPath
}

const logNamespace = 'sounds'
export function load(audioJson: any, musicPath: string) {
  _musicPath = musicPath + '/'
  console.log('music path', _musicPath)
  soundsGeneric.load(audioJson, () => {
    log.x(logNamespace, 'loaded')
    if (doPlayLoaded) {
      playLoaded()
    }
    if (soundTest) {
      setInterval(() => {
        playLoaded()
      }, 500)
    }
  })
  playMusicMenu()
}

export function toggleSounds() {
  let mute = settings.get().muteSound
  settings.update({ muteSound: !mute, muteAmbient: !mute })
  if (!mute) {
    soundsGeneric.stopAllSounds()
  }
}

export function toggleMusic() {
  settings.update({ muteMusic: !settings.get().muteMusic })
}

// -- current below

// TODO: replace all of these
export function playMusic1() {
  // need new!
  // soundsGeneric.playMusic(_musicPath + 'loop')
  // soundsGeneric.playMusic(_musicPath + 'theme1')
}
export function playMusicMenu() {
  // need new!
  // soundsGeneric.playMusic(_musicPath + 'theme1')
}
export function playLoaded() {
  playSuccess()
}
export function playbuttonMouseOver() {
  soundsGeneric.play(_audioSprite2.AnalogButton, 0.33)
}

export function playButtonClick() {
  soundsGeneric.playRandom([
    // _audioSprite2.Button_01,
    _audioSprite2.Button_01_Variation_01,
    _audioSprite2.Button_01_Variation_02,
    _audioSprite2.Button_01_Variation_03,
  ])
}

export function playSelected() {
  soundsGeneric.playRandom([_audioSprite2.Button_01], 0.5)
}

export function playSuccess() {
  soundsGeneric.playRandom([_audioSprite2.Analysis_Single_03], 0.5)
}
export function playFailure() {
  soundsGeneric.playRandom([_audioSprite2.Negative_02], 1)
}

export function playFireExtinguisher() {
  soundsGeneric.play(_audioSprite2.fireExtingusher1, 0.25)
}

export function playRepair() {
  soundsGeneric.playRandom(
    [_audioSprite2.repair1, _audioSprite2.blowtorch1], //, _audioSprite2.repair2, _audioSprite2.repair3],
    0.75,
  )
}

export function playCompWarning1() {
  soundsGeneric.playRandom([_audioSprite2.compwarn1], 0.5)
}
export function playCompWarning2() {
  soundsGeneric.playRandom([_audioSprite2.compwarn2], 0.5)
}

export function playTeleport() {
  soundsGeneric.playRandom([_audioSprite2.teleport1], 0.75)
}

export function playFootstep() {
  soundsGeneric.playRandom(
    [
      _audioSprite2.footMetal1,
      _audioSprite2.footMetal2,
      _audioSprite2.footMetal3,
      _audioSprite2.footMetal4,
      _audioSprite2.footMetal5,
      // _audioSprite2.foot1,
      // _audioSprite2.foot2,
      // _audioSprite2.foot3,
      // _audioSprite2.foot4,
    ],
    0.4,
  )
}

export function playExplosion() {
  soundsGeneric.playRandom(
    [
      _audioSprite2.MediumExplosion1,
      _audioSprite2.MediumExplosion2,
      _audioSprite2.MediumExplosion3,
    ],
    0.5,
  )
}

export function playExplosionFire() {
  soundsGeneric.playRandom(
    [
      _audioSprite2.FireExplosion7,
      _audioSprite2.FireExplosion8,
      _audioSprite2.FireExplosion9,
    ],
    0.5,
  )
}

export function playExplosionMetalDebris() {
  soundsGeneric.playRandom(
    [
      _audioSprite2.MetalDebris1,
      _audioSprite2.MetalDebris2,
      _audioSprite2.MetalDebris3,
    ],
    0.5,
  )
}

export function playFireLaser() {
  soundsGeneric.playRandom(
    [
      _audioSprite2.SciFiExplosion15,
      _audioSprite2.SciFiExplosion16,
      _audioSprite2.SciFiExplosion17,
    ],
    0.6,
  )
}

export function playFireTorpedo() {
  soundsGeneric.playRandom(
    [_audioSprite2.Gun1, _audioSprite2.Gun2, _audioSprite2.Gun3],
    1,
  )
}

export function playLoadTorpedo() {
  soundsGeneric.playRandom([_audioSprite2.gunLoad1], 0.75)
}

export function playEnemyShipDefeated() {
  soundsGeneric.playRandom([_audioSprite2.DistantBigExplosion4], 0.8)
}

export function playShootAlienGun() {
  soundsGeneric.playRandom(
    [_audioSprite2.SciFiExplosion21, _audioSprite2.SciFiExplosion22],
    0.6,
  )
}
export function playShootCrewGun() {
  soundsGeneric.playRandom(
    [
      _audioSprite2.SciFiExplosion23,
      _audioSprite2.SciFiExplosion24,
      _audioSprite2.SciFiExplosion25,
    ],
    0.6,
  )
}

export function playCantMoveThere() {
  soundsGeneric.playRandom([_audioSprite2.Negative_02], 1)
}

export function playDeathAlien() {
  soundsGeneric.playRandom(
    [_audioSprite2.dieAlien1, _audioSprite2.dieAlien2],
    0.5,
  )
}
export function playDeathCrewmember() {
  soundsGeneric.playRandom(
    [
      _audioSprite2.diefemale1,
      _audioSprite2.diefemale2,
      _audioSprite2.diefemale3,
      _audioSprite2.diefemale4,
      _audioSprite2.diemale1,
      _audioSprite2.diemale2,
      _audioSprite2.dieMale3,
    ],
    0.5,
  )
}
// export function play(soundName: string) {
//   soundsGeneric.play(soundName)
// }

// Links to other systems
// pubSub.on('gui:click-button', () => {
//   playButtonClick()
// })
